"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("@src/app/commons/Constants");
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/xs/controllers/base-class');
/*
  PluginControls handles the various controls, knobs and dials a plugin might need the user to tweak
*/
class XsBaseClass {
    constructor(config = {}, defaults = null) {
        this.debug = Constants_1.Constants.debug_off;
        this.debugStyle = 'color:#fff;background-color:#921;';
        this.debugId = 'BASE';
        this.parentClass = null;
        // our config
        this._config = {};
        // our property store
        this._props = {};
        this.parentClass = this.constructor.name;
        DEBUG_1.DEBUG.log('/xs/controllers/base-class');
        if (this['_config_default']) {
            this.__config(this['_config_default']);
        }
        if (defaults) {
            this.__config(defaults);
        }
        if (config) {
            this.__config(config);
        }
    }
    /* getters, setters, and Proxy wrapping implementation classes */
    __getset(key) {
        const me = this;
    }
    __getter(key) {
        const me = this;
        // console.log('C.get('+key+')', me[key], me[key] ? me[key]['__xs_prop'] : false );
        if (!me.hasOwnProperty(key)) {
            me[key] = { value: null, __xs_prop: true };
        }
        if (me[key] && me[key]['__xs_prop']) {
            return { value: me[key].value };
        }
        return me[key];
    }
    __setter(key, value) {
        const me = this;
        if (!me.hasOwnProperty(key)) {
            me[key] = { value: value, __xs_prop: true };
        }
        if (me[key] && me[key]['__xs_prop']) {
            me[key] = { value: value, __xs_prop: true };
        }
        else {
            me[key] = value;
        }
        // console.log('C.set('+key+')',me[key]);
        return true;
    }
    __proxyFactory() {
        const me = this;
        return new Proxy(me, {
            set(object, key, value) {
                return me.__setter(key, value);
            },
            get(object, key) {
                return me.__getter(key);
            }
        });
    }
    /* configure our class */
    __config(config = null) {
        Object.keys(config).forEach(k => {
            if (config.hasOwnProperty(k)) {
                this._config[k] = config[k];
            }
        });
    }
    __props(props = null) {
        Object.keys(props).forEach(k => {
            if (props.hasOwnProperty(k)) {
                this._props[k] = props[k];
            }
        });
    }
    /* debug our class */
    __log(funcy = '??', data = '') {
        if (this.debug) {
            console.log('%c __' + this.debugId + ' %c ' + funcy + ' %c ' + this.parentClass + ' ', Constants_1.Constants._red, Constants_1.Constants._black, Constants_1.Constants._gray, data);
        }
    }
    __uuidv4(token = '-', prefix = '') {
        return (prefix + 'xxxxxxxx' + token + 'xxxx' + token + '4xxx' + token + 'yxxx' + token + 'xxxxxxxxxxxx').replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    // reach sets properties of the current object (this) according to a path (delimited by '.');
    //  - reach ( 'myProp', value ) = this.myProp = value
    //  - reach ( 'someObj.subObj.myValue', value ) = this.someObj.subObj.myValue = value
    __reach(sofar = null, path = '', data = null) {
        if (!sofar) {
            return null;
        }
        if (path.indexOf('.') !== -1) {
            let token = path.split('.')[0];
            let after = path.substring(path.indexOf('.') + 1);
            return this.__reach(sofar[token], after, data);
        }
        else {
            if (data) {
                sofar[path] = data;
            }
            return sofar[path];
        }
    }
}
exports.XsBaseClass = XsBaseClass;
